<template>
  <div class="follow-page">
    <div class="page-header">
      <span class="page-title">我的自动跟注</span>
      <div class="header-actions">
        <el-button icon="el-icon-refresh" size="small" :loading="loading" @click="loadAll">刷新</el-button>
        <el-button size="small" @click="goZhaogu">众筹招股大厅</el-button>
        <el-button size="small" @click="goMySubscribe">我的认购记录</el-button>
      </div>
    </div>

    <!-- 规则说明 -->
    <div class="rule-card">
      <div class="rule-title">跟注规则</div>
      <div class="rule-content">
        跟注是<b>按投注站</b>来的：您在某个投注站认购过众筹招股后，才能开启对该投注站的跟注；
        开启后该投注站<b>之后新发布</b>的众筹招股会由系统自动按设定股数认购，
        <b>其他投注站发布的众筹不会跟</b>。每个投注站独立开关、独立设置跟注股数。
      </div>
      <div class="rule-content sub">
        每期跟注受 <b>缩币余额</b>、<b>个人认购上限</b>（散户 2 股，缩水师/技巧师/软件工程师每具备一种 +2 股，单人最多 8 股）、
        <b>当期剩余份额</b> 三重约束；任一项不满足则当期自动跳过、不扣币，并在下方记录原因，下期继续尝试。
      </div>
    </div>

    <!-- 投注站列表 -->
    <div class="log-header">
      <span class="log-title">已关注的投注站</span>
      <span class="log-tip">一个投注站一条跟注设置，互不影响。</span>
    </div>

    <el-table class="shop-table" :data="shopList" border v-loading="shopLoading"
      empty-text="您还没有跟注任何投注站"
      :header-cell-style="{ background: '#347caf', color: '#fff', textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }">
      <el-table-column label="投注站编号" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ shopLabel(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="跟注状态" width="88">
        <template slot-scope="scope">
          <el-tag v-if="Number(scope.row.enabled) === 1" type="success" size="mini" effect="dark">已开启</el-tag>
          <el-tag v-else size="mini" type="info">已关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="每期跟注" width="88">
        <template slot-scope="scope">{{ scope.row.shares }} 股</template>
      </el-table-column>
      <el-table-column label="认购情况" width="105">
        <template slot-scope="scope">
          <span v-if="scope.row.subscribed">已认购 {{ scope.row.subscribedIssueCount }} 期</span>
          <span v-else class="txt-warn">未认购</span>
        </template>
      </el-table-column>
      <el-table-column prop="followTimes" label="跟注次数" width="90" />
      <el-table-column label="最近成功跟注" width="160">
        <template slot-scope="scope">{{ scope.row.lastFollowTime || '-' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="185">
        <template slot-scope="scope">
          <el-button type="text" @click="toggleFollow(scope.row)">
            {{ Number(scope.row.enabled) === 1 ? '关闭跟注' : '开启跟注' }}
          </el-button>
          <el-button type="text" @click="openSharesDialog(scope.row)">改股数</el-button>
          <el-button type="text" class="txt-danger" @click="cancelFollow(scope.row)">取消</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="empty-guide" v-if="!shopLoading && shopList.length === 0">
      还没有跟注任何投注站。前往
      <el-button type="text" @click="goZhaogu">众筹招股大厅</el-button>
      认购某个投注站发布的众筹后，即可在详情页开启对该投注站的自动跟注。
    </div>

    <!-- 跟注记录 -->
    <div class="log-header" style="margin-top: 26px">
      <span class="log-title">跟注记录</span>
      <span class="log-tip">系统每期自动执行一次，成功与失败都会记录在这里。</span>
      <div class="log-filter">
        <el-select v-model="filterShopId" size="small" clearable placeholder="全部投注站"
          style="width: 170px" @change="onFilterChange">
          <el-option v-for="s in shopList" :key="s.shopUserId" :label="s.shopName || ('投注站' + s.shopUserId)"
            :value="s.shopUserId" />
        </el-select>
      </div>
    </div>

    <el-table class="follow-table" :data="list" border v-loading="loading" empty-text="暂无跟注记录"
      :header-cell-style="{ background: '#347caf', color: '#fff', textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }">
      <el-table-column type="index" label="#" width="50" :index="indexMethod" />
      <el-table-column label="投注站编号" width="130" show-overflow-tooltip>
        <template slot-scope="scope">{{ shopLabel(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="title" label="众筹标题" min-width="160" show-overflow-tooltip />
      <el-table-column prop="issueNumber" label="期号" width="110" />
      <el-table-column label="彩种" width="100">
        <template slot-scope="scope">{{ scope.row.lotteryTypeIntro || lotteryTypeName(scope.row.lotteryType) }}</template>
      </el-table-column>
      <el-table-column label="跟注股数" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1">{{ scope.row.shares }} 股</span>
          <span v-else class="txt-muted">-</span>
        </template>
      </el-table-column>
      <el-table-column label="扣减缩币" width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1">{{ money(scope.row.cost) }}</span>
          <span v-else class="txt-muted">-</span>
        </template>
      </el-table-column>
      <el-table-column label="结果" width="150">
        <template slot-scope="scope">
          <el-tag :type="statusTagType(scope.row.status)" size="mini" effect="dark">
            {{ scope.row.statusIntro || '未知' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="失败原因" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1" class="txt-muted">-</span>
          <span v-else>{{ scope.row.failReason || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="跟注时间" width="170" />
      <el-table-column label="操作" width="90" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row.crowdfundingId)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="fenye" v-if="total > 0">
      <el-pagination background layout="prev, pager, next" :total="total"
        :page-size="pageSize" :current-page="pageNum" @current-change="onPage"></el-pagination>
    </div>

    <!-- 修改跟注股数 -->
    <el-dialog title="修改跟注股数" :visible.sync="sharesDialogVisible" width="360px" append-to-body>
      <div v-if="currentShop" class="shares-form">
        <div class="shares-tip">
          投注站：{{ currentShop.shopName || ('投注站' + currentShop.shopUserId) }}
        </div>
        <div class="shares-row">
          <span>每期跟注</span>
          <el-input-number v-model="sharesForm.shares" :min="1" :max="8" size="small" controls-position="right" />
          <span>股</span>
        </div>
        <div class="shares-note">每期最多可跟注 8 股，实际成交还受余额与个人认购上限约束。</div>
      </div>
      <div slot="footer">
        <el-button size="small" @click="sharesDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submitShares">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  crowdfundingFollowShopList,
  crowdfundingFollowSave,
  crowdfundingFollowCancel,
  crowdfundingFollowMyLogList,
  crowdfundingFollowLimit,
} from "@/api/apply";

const LOTTERY_MAP = {
  '0': '双色球', '1': '大乐透', '2': '福彩3D', '3': '排列3',
  '5': '七乐彩', '6': '7星彩', '7': '排列5', '8': '快乐8',
};

export default {
  name: "CrowdfundingFollow",
  data() {
    return {
      loading: false,
      shopLoading: false,
      saving: false,
      shopList: [],
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      filterShopId: undefined,
      sharesDialogVisible: false,
      currentShop: null,
      sharesForm: { shares: 2 },
      followMaxShares: 2, // 按身份的上限（散户2股，缩水师/技巧师/软件工程师每具备一种+2，封顶8）；初始保守取基准2，mounted 时从后端 /limit 取真实值覆盖
    };
  },
  mounted() {
    this.loadAll();
    this.loadFollowLimit();
  },
  methods: {
    goZhaogu() {
      this.$router.push("/sttzzbfzx/zhaogu");
    },
    goMySubscribe() {
      this.$router.push("/sttzzbfzx/my/subscribe");
    },
    goDetail(id) {
      if (id == null) return;
      this.$router.push("/sttzzbfzx/zhaogu/detail/" + id);
    },
    lotteryTypeName(type) {
      return LOTTERY_MAP[type] || type || "-";
    },
    money(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return isNaN(n) ? v : n;
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    statusTagType(status) {
      const s = Number(status);
      if (s === 1) return "success";
      if (s === 2) return "danger";   // 缩币余额不足
      if (s === 3) return "warning";  // 当期剩余份额不足
      return "info";
    },
    loadAll() {
      this.loadShopList();
      this.loadLog();
    },
    // 查询当前用户按身份可设置的最大跟注股数（与认购单人上限同一口径）
    loadFollowLimit() {
      crowdfundingFollowLimit()
        .then((res) => {
          const data = res && res.data !== undefined ? res.data : res;
          const n = Number(data);
          if (!isNaN(n) && n >= 1) {
            this.followMaxShares = Math.min(Math.floor(n), 8);
          }
          this.warnOverLimitShares();
        })
        .catch(() => {});
    },
    // 已设置股数若超出身份上限，提示用户调整（后端保存时也会拦截）
    warnOverLimitShares() {
      const over = this.shopList.find((r) => Number(r.shares) > this.followMaxShares);
      if (over) {
        this.$message.warning(`您的身份最多可跟注 ${this.followMaxShares} 股，「${this.shopLabel(over)}」已设置的 ${over.shares} 股需调整后才会生效`);
      }
    },
    loadShopList() {
      this.shopLoading = true;
      crowdfundingFollowShopList()
        .then((res) => {
          const data = res && res.data !== undefined ? res.data : res;
          const arr = Array.isArray(data) ? data : (data && (data.list || data.rows)) || [];
          this.shopList = Array.isArray(arr) ? arr : [];
          this.warnOverLimitShares();
        })
        .catch(() => {
          this.shopList = [];
        })
        .finally(() => {
          this.shopLoading = false;
        });
    },
    // 投注站展示名：优先投注站编号（如 6.36886.net），无编号退回名称
    shopLabel(row) {
      if (!row) return "该投注站";
      return row.shopNumber || row.shopName || "投注站" + row.shopUserId;
    },
    // 开启/关闭对某个投注站的跟注
    toggleFollow(row) {
      const enable = Number(row.enabled) !== 1;
      if (enable && !row.subscribed) {
        this.$confirm(
          `您还没有认购过${this.shopLabel(row)}的众筹招股，需先认购一次才能开启跟注。是否前往众筹招股大厅？`,
          "无法开启跟注",
          { confirmButtonText: "去认购", cancelButtonText: "取消", type: "warning" }
        ).then(() => {
          this.goZhaogu();
        }).catch(() => {});
        return;
      }
      this.doSave(row.shopUserId, enable, Math.min(Number(row.shares) || 2, this.followMaxShares), enable ? null : "已关闭对该投注站的自动跟注");
    },
    openSharesDialog(row) {
      this.currentShop = row;
      this.sharesForm.shares = Math.min(Math.max(Number(row.shares) || 2, 1), this.followMaxShares);
      this.sharesDialogVisible = true;
    },
    submitShares() {
      if (!this.currentShop) return;
      const enabled = Number(this.currentShop.enabled) === 1;
      this.doSave(this.currentShop.shopUserId, enabled, this.sharesForm.shares, null, () => {
        this.sharesDialogVisible = false;
      });
    },
    cancelFollow(row) {
      this.$confirm(
        `取消后将不再自动跟注「${this.shopLabel(row)}」发布的众筹招股，已产生的跟注记录与认购不受影响。确认取消？`,
        "取消跟注",
        { confirmButtonText: "确认取消", cancelButtonText: "再想想", type: "warning" }
      ).then(() => {
        this.saving = true;
        crowdfundingFollowCancel(row.shopUserId)
          .then((res) => {
            if (res && res.code === 200) {
              this.$message.success((res && res.msg) || "已取消跟注");
            } else {
              this.$message.error((res && res.msg) || "操作失败");
            }
          })
          .catch(() => {})
          .finally(() => {
            this.saving = false;
            this.loadAll();
          });
      }).catch(() => {});
    },
    doSave(shopUserId, enabled, shares, tipMsg, done) {
      this.saving = true;
      crowdfundingFollowSave({
        shopUserId: Number(shopUserId),
        enabled: !!enabled,
        shares: Math.min(Math.max(Number(shares) || 2, 1), this.followMaxShares),
      })
        .then((res) => {
          if (res && res.code === 200) {
            this.$message.success((res && res.msg) || tipMsg || "设置成功");
          } else {
            this.$message.error((res && res.msg) || "设置失败");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.saving = false;
          // 无论成功失败都以服务端为准刷新，避免界面与真实状态不一致
          this.loadShopList();
          this.loadLog();
          if (typeof done === "function") done();
        });
    },
    loadLog() {
      this.loading = true;
      const params = { pageNum: this.pageNum, pageSize: this.pageSize };
      if (this.filterShopId) params.shopUserId = this.filterShopId;
      crowdfundingFollowMyLogList(params)
        .then((res) => {
          const rows = (res && res.rows) || (res && res.data && res.data.rows) || [];
          const total = (res && res.total) || (res && res.data && res.data.total) || 0;
          this.list = rows;
          this.total = total;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    onFilterChange() {
      this.pageNum = 1;
      this.loadLog();
    },
    onPage(page) {
      this.pageNum = page;
      this.loadLog();
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-page {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  min-height: 400px;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
  border-bottom: 2px solid #347caf;
  margin-bottom: 18px;

  .page-title {
    font-size: 20px;
    font-weight: bold;
    color: #347caf;
  }

  .header-actions {
    display: flex;
    gap: 8px;
  }
}

.rule-card {
  padding: 14px 18px;
  background: #f5f9fd;
  border: 1px solid #d6e6f5;
  border-radius: 6px;
  margin-bottom: 20px;

  .rule-title {
    font-size: 15px;
    font-weight: bold;
    color: #347caf;
    margin-bottom: 8px;
  }

  .rule-content {
    font-size: 12px;
    color: #7a8b99;
    line-height: 20px;

    b {
      color: #347caf;
      padding: 0 2px;
    }

    &.sub {
      margin-top: 6px;
    }
  }
}

.log-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  .log-title {
    font-size: 16px;
    font-weight: bold;
    color: #347caf;
  }

  .log-tip {
    font-size: 12px;
    color: #9aa8b4;
  }

  .log-filter {
    margin-left: auto;
  }
}

.empty-guide {
  margin-top: 12px;
  padding: 14px 16px;
  background: #fcf8e8;
  border: 1px dashed #e6c98a;
  border-radius: 6px;
  font-size: 13px;
  color: #8a6d3b;
  line-height: 22px;
}

.shares-form {
  .shares-tip {
    font-size: 13px;
    color: #5a6b7a;
    margin-bottom: 14px;
  }

  .shares-row {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: #5a6b7a;
  }

  .shares-note {
    margin-top: 12px;
    font-size: 12px;
    color: #9aa8b4;
    line-height: 18px;
  }
}

.txt-muted {
  color: #b6c2cc;
}

.txt-warn {
  color: #e6a23c;
}

::v-deep .txt-danger {
  color: #f56c6c;
}

.fenye {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
